import React from 'react';

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export default class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('ErrorBoundary caught:', error, info.componentStack);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="text-center py-5">
          <div className="mb-3" style={{ fontSize: '3rem' }}>&#9888;</div>
          <h4 className="mb-2">Something went wrong</h4>
          <p className="text-muted mb-3">
            {this.state.error?.message || 'An unexpected error occurred.'}
          </p>
          <button className="btn btn-sm" style={{ background: '#FB2832', color: '#fff', border: 'none' }} onClick={this.handleRetry}>
            Try Again
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
